import Vue from "vue";

Vue.directive('close-dropdown', {

    bind(el) {
        el.onclick = function(event) {
            $(el).closest('.dropdown-toggle').dropdown('toggle');
        };
    },
});

